export const truncateDescription = (description: string) => {
  const maxLength = 186;
  if (description.length > maxLength) {
    const truncated = description.substring(0, maxLength);
    const lastPeriodIndex = truncated.lastIndexOf('.');
    return lastPeriodIndex !== -1
      ? truncated.substring(0, lastPeriodIndex + 1)
      : truncated;
  }
  return description;
};
